<div class="encolumnat">
    <h1 class="titol">{{ 'REGISTERCOMPONENT.PRODUCTS_INFO.TITLE' | translate }}</h1>
    <shared-products-component class="register" [products]="registerData.products"
        (onProductChange)="productChange($event)">
    </shared-products-component>
    <div class="button-zone">
        <button mat-flat-button color="primary" class="action seguent sol"
            (click)="next()" [disabled]="pendigResponse">{{'REGISTERCOMPONENT.FINISHBUTTON.LABEL' | translate}}</button>
    </div>
</div>